'use client';

import { appRoutes } from 'config';
import useAuthenticatedUser from 'networking/mindfeed/hooks/useAuthenticatedUser';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import {
  Reveal,
  Section8,
  Section9,
  Section10,
  Section11,
  Section12,
  Section13,
  Section14,
  Section15,
  Section16,
  Section17,
} from 'modules/Landing';

const Home = () => {
  const { authenticatedUser } = useAuthenticatedUser();
  const router = useRouter();

  useEffect(() => {
    if (authenticatedUser) {
      router.push(appRoutes.MEMORY_SPACE);
    }
  }, [authenticatedUser, router]);

  return (
    <ParallaxProvider>
      <div className="p-0 flex font-inter">
        <div className="w-full mx-auto">
          <Section8 animateVisuals />
          <Reveal>
            <Section9 />
          </Reveal>
          <Reveal>
            <Section10 />
          </Reveal>
          <Reveal>
            <Section11 />
          </Reveal>
          <Reveal>
            <Section12 />
          </Reveal>
          <Reveal>
            <Section13 />
          </Reveal>
          <Reveal>
            <Section14 />
          </Reveal>
          <Reveal>
            <Section15 />
          </Reveal>
          <Reveal>
            <Section16 />
          </Reveal>
          <Reveal>
            <Section17 />
          </Reveal>
        </div>
      </div>
    </ParallaxProvider>
  );
};

export default Home;
